import React from 'react';
import { Provider } from 'react-redux';
import { SkeletonTheme } from 'react-loading-skeleton';
import store, { actions, getters } from 'redux/store';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { ProvideAPI } from 'utils/api';
import { ProvideCallback } from 'utils/callback';
import { ProvideMount } from 'utils/mount';
import { ProvideAlert } from 'utils/alert';
import { ProvideLoading } from 'utils/loading';
import { skeletonBaseColor } from 'utils/colors';

import 'react-loading-skeleton/dist/skeleton.css';

export default ({ element }) => {
  // Instantiating store in `wrapRootElement` handler ensures:
  //  - there is fresh store for each SSR page
  //  - it will be called only once in browser, when React mounts
  // const store = createStore();
  const queryClient = new QueryClient();
  return (
    // <Provider store={store}>
    //   <ProvideAPI>{element}</ProvideAPI>
    // </Provider>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ProvideAPI>
          <ProvideCallback>
            <ProvideMount>
              <ProvideLoading>
                <ProvideAlert>
                  <SkeletonTheme baseColor={skeletonBaseColor}>
                    {element.props.children}
                  </SkeletonTheme>
                </ProvideAlert>
              </ProvideLoading>
            </ProvideMount>
          </ProvideCallback>
        </ProvideAPI>
      </QueryClientProvider>
    </Provider>
  );
};
